import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';

import { DialogModule } from '@main-client/src/app/dialog/dialog.module';

import { DialogSessionsSettingsComponent } from '@main-client/src/app/settings/dialog-sessions-settings/dialog-sessions-settings.component';

@NgModule({
  declarations: [DialogSessionsSettingsComponent],
  exports: [DialogSessionsSettingsComponent],
  imports: [
    CommonModule,
    DialogModule,
    FlexLayoutModule,
    MatButtonModule,
    MatDialogModule,
  ],
})
export class DialogSessionSettingsModule {}
